import React from 'react';

const WhyChooseUs = () => {
  const reasons = [
    {
      title: 'Enterprise Architecture',
      image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=500&q=80',
      desc: 'Microservices, serverless, and cloud-native architecture built for 99.99% SLA uptime.',
      color: '#6C63FF',
      tag: 'Cloud-Native',
    },
    {
      title: 'Agile Development',
      image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=500&q=80',
      desc: 'Bi-weekly sprints, continuous integration, and rapid prototype delivery.',
      color: '#00D4FF',
      tag: 'Agile Sprints',
    },
    {
      title: 'Dedicated Team',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=500&q=80',
      desc: 'Senior software engineers, AI architects, and UI/UX designers dedicated to your product.',
      color: '#8B5CF6',
      tag: 'Elite Engineers',
    },
    {
      title: 'Transparent Process',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=500&q=80',
      desc: 'Full Jira, GitHub, and Slack visibility with weekly sprint demos & code commits.',
      color: '#10B981',
      tag: '100% Visibility',
    },
    {
      title: 'Secure Development',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=500&q=80',
      desc: 'SOC2, ISO27001, OWASP Top 10, and HIPAA compliance baked into dev pipelines.',
      color: '#F59E0B',
      tag: 'SOC2 Compliant',
    },
    {
      title: '24/7 Enterprise Support',
      image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=500&q=80',
      desc: 'Round-the-clock monitoring, immediate SLA escalation, and active bug resolution.',
      color: '#EC4899',
      tag: '24/7 NOC SLA',
    },
    {
      title: 'Cost Effective Engineering',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=500&q=80',
      desc: 'High ROI through automated engineering, reusable modular assets, and efficient scaling.',
      color: '#3B82F6',
      tag: 'Max ROI',
    },
  ];

  return (
    <section
      id="why-choose-us"
      style={{
        padding: '56px 0',
        position: 'relative',
        zIndex: 2,
        background: 'linear-gradient(180deg, #0B0F24 0%, #060816 100%)',
      }}
    >
      <div className="ht-container">
        {/* Section Header */}
        <div className="section-header" style={{ marginBottom: '28px' }}>
          <span className="section-tag">WHY CHOOSE US</span>
          <h2 className="text-gradient" style={{ fontSize: 'clamp(1.8rem, 3.4vw, 2.6rem)', fontWeight: 800 }}>
            Engineered for Excellence and Reliability
          </h2>
          <p style={{ color: '#A3A8B8', fontSize: '0.98rem', maxWidth: '700px', margin: '6px auto 0 auto' }}>
            Why leading enterprises and fast-growing tech startups choose Hungry Top Technologies as their core tech partner.
          </p>
        </div>

        {/* 3-Column Image Cards Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '18px',
          }}
        >
          {reasons.map((item, idx) => (
            <div
              key={idx}
              className="glass-card"
              style={{
                padding: '16px',
                borderRadius: '16px',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                background: 'rgba(15, 23, 42, 0.75)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <div>
                {/* Small Cover Image Banner */}
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    height: '105px',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    marginBottom: '14px',
                    background: 'rgba(6, 8, 22, 0.8)',
                    border: `1px solid ${item.color}33`,
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    onError={(e) => {
                      e.currentTarget.style.display = 'none';
                    }}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block',
                      filter: 'brightness(0.85)',
                    }}
                  />
                  {/* Subtle Gradient & Tag Overlay */}
                  <div
                    style={{
                      position: 'absolute',
                      inset: 0,
                      background: `linear-gradient(180deg, transparent 40%, rgba(6, 8, 22, 0.9) 100%)`,
                    }}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      bottom: '6px',
                      left: '8px',
                      fontSize: '0.64rem',
                      fontWeight: 800,
                      color: item.color,
                      textTransform: 'uppercase',
                      letterSpacing: '0.06em',
                      background: 'rgba(6, 8, 22, 0.85)',
                      padding: '2px 7px',
                      borderRadius: '4px',
                      border: `1px solid ${item.color}44`,
                    }}
                  >
                    {item.tag}
                  </span>
                </div>

                <h3 style={{ fontSize: '1.08rem', color: '#FFF', marginBottom: '6px', fontWeight: 800, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  {item.title}
                </h3>
                <p style={{ fontSize: '0.84rem', color: '#A3A8B8', lineHeight: 1.48 }}>
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
